import { render, staticRenderFns } from "./SquidLevelsModal.vue?vue&type=template&id=b86de166&scoped=true&"
import script from "./SquidLevelsModal.vue?vue&type=script&lang=js&"
export * from "./SquidLevelsModal.vue?vue&type=script&lang=js&"
import style0 from "./SquidLevelsModal.vue?vue&type=style&index=0&id=b86de166&lang=scss&scoped=true&"
import style1 from "./SquidLevelsModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86de166",
  null
  
)

export default component.exports